interface Props {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  perPage: number;
  onPageChange: (page: number) => void;
}

export default function PaginacaoSementes({
  currentPage,
  totalPages,
  totalItems,
  perPage,
  onPageChange,
}: Props) {
  const startItem = totalItems > 0 ? (currentPage - 1) * perPage + 1 : 0;
  const endItem = Math.min(currentPage * perPage, totalItems);

  const renderPages = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i += 1) {
        pages.push(
          <button
            key={i}
            type="button"
            className={`paginacao-btn ${i === currentPage ? 'active' : ''}`}
            onClick={() => onPageChange(i)}
            disabled={totalItems === 0}
          >
            {i}
          </button>,
        );
      }
    } else {
      pages.push(
        <button
          key={1}
          type="button"
          className={`paginacao-btn ${currentPage === 1 ? 'active' : ''}`}
          onClick={() => onPageChange(1)}
          disabled={totalItems === 0}
        >
          1
        </button>,
      );

      if (currentPage > 3) {
        pages.push(<span key="start-ellipsis" className="paginacao-ellipsis">...</span>);
      }

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i += 1) {
        if (i !== 1 && i !== totalPages) {
          pages.push(
            <button
              key={i}
              type="button"
              className={`paginacao-btn ${i === currentPage ? 'active' : ''}`}
              onClick={() => onPageChange(i)}
              disabled={totalItems === 0}
            >
              {i}
            </button>,
          );
        }
      }

      if (currentPage < totalPages - 2) {
        pages.push(<span key="end-ellipsis" className="paginacao-ellipsis">...</span>);
      }

      pages.push(
        <button
          key={totalPages}
          type="button"
          className={`paginacao-btn ${totalPages === currentPage ? 'active' : ''}`}
          onClick={() => onPageChange(totalPages)}
          disabled={totalItems === 0}
        >
          {totalPages}
        </button>,
      );
    }

    return pages;
  };

  return (
    <div className="paginacao">
      <div className="paginacao-info">
        Mostrando {startItem}-{endItem} de {totalItems} resultados
      </div>

      <div className="paginacao-controls">
        <button
          type="button"
          className={`paginacao-btn chevron ${currentPage === 1 || totalItems === 0 ? 'disabled' : ''}`}
          disabled={currentPage === 1 || totalItems === 0}
          onClick={() => onPageChange(currentPage - 1)}
        >
          ‹
        </button>

        {renderPages()}

        <button
          type="button"
          className={`paginacao-btn chevron ${currentPage === totalPages || totalItems === 0 ? 'disabled' : ''}`}
          disabled={currentPage === totalPages || totalItems === 0}
          onClick={() => onPageChange(currentPage + 1)}
        >
          ›
        </button>
      </div>
    </div>
  );
}
